import { render } from "./JrvPickStreamlined.vue?vue&type=template&id=d0732f88&scoped=true"
import script from "./JrvPickStreamlined.vue?vue&type=script&lang=ts"
export * from "./JrvPickStreamlined.vue?vue&type=script&lang=ts"

import "./JrvPickStreamlined.vue?vue&type=style&index=0&id=d0732f88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0732f88"

export default script